import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/useAuth";

const ProtectedRoute = ({ children }) => {
  const { token, loading } = useAuth();   // ✅ FIXED

  if (loading) return <div>Loading...</div>;

  if (!token) return <Navigate to="/auth/login" replace />;

  return children;
};

export default ProtectedRoute;
